interface Props {
  /** Rendered size in px. The art is designed to survive down to 16. */
  size?: number;
  className?: string;
}

/**
 * The game's mark: a magnifier over a board, one column flagged.
 *
 * Inlined rather than loaded from /brand/detective-icon.svg so it inherits the
 * page's colour and needs no extra request, and because an inline SVG can be
 * given a title for assistive tech. The standalone file exists for the favicon
 * and anywhere outside React; keep the two in step if the art changes.
 */
export function DetectiveMark({ size = 28, className }: Props) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label="DevTool Detective"
    >
      <defs>
        {/* Unique per instance is unnecessary here: the clip is identical
            everywhere, and duplicate ids of the same shape are harmless. */}
        <clipPath id="dd-lens-clip">
          <circle cx="27" cy="27" r="13" />
        </clipPath>
      </defs>

      <rect width="64" height="64" rx="14" fill="#1a3e6e" />
      <path
        d="M37.5 37.5 L50.5 50.5"
        stroke="#e75e26"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <circle cx="27" cy="27" r="13" fill="#0f2547" />
      <g clipPath="url(#dd-lens-clip)">
        <rect x="16.5" y="21" width="5" height="18" rx="1.5" fill="#8fa8c8" />
        <rect x="24.5" y="17" width="5" height="22" rx="1.5" fill="#8fa8c8" />
        <rect x="32.5" y="24" width="5" height="15" rx="1.5" fill="#e75e26" />
      </g>
      <circle cx="27" cy="27" r="13" fill="none" stroke="#ffffff" strokeWidth="4" />
    </svg>
  );
}
